import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=c9e19e84&scoped=true&"
import script from "./list2.vue?vue&type=script&lang=js&"
export * from "./list2.vue?vue&type=script&lang=js&"
import style0 from "./list2.vue?vue&type=style&index=0&id=c9e19e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e19e84",
  null
  
)

export default component.exports